const SvgSilver = props => (
  <svg
    width={24}
    height={23}
    viewBox="0 0 24 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect y={0.229492} width={24} height={22.2294} rx={11.1147} fill="#949494" />
    <path
      d="M4.47537 17.1843C3.01479 12.7058 4.07492 3.84761 20 4.24225C14.709 4.46471 4.19679 7.36455 4.47537 17.1843Z"
      fill="white"
    />
    <path
      d="M5.42395 18.412C16.8919 19.2013 19.6621 9.82264 19.6138 5.03467C16.2012 14.924 9.98945 17.2609 7.31012 17.1932C7.26369 13.1539 12.0304 9.08752 14.4195 7.55923C7.38557 9.57889 5.49166 15.6359 5.42395 18.412Z"
      fill="white"
    />
  </svg>
);
export default SvgSilver;
